import { UseGetApiSimple } from "beaktShared/services/crudeApiService";

// BKT-1510: auditoria de contrato/reajuste de Royalties por unidade (API BKT-1505). O usuário vem do token.
const ENDPOINT = "AuditoriaContrato";

// Descarta itens fora do contrato AuditoriaContratoItemDto (sem id numérico)
const registrosValidos = (data) =>
    Array.isArray(data)
        ? data.filter(r => r && typeof r.estabelecimentoContratoLogId === "number")
        : [];

// Retorna { ok, data, message }; o helper devolve undefined quando a sessão expira (recarrega a página)
const getAuditoriaContrato = (estabelecimentoId) =>
    Promise.resolve(UseGetApiSimple(`${ENDPOINT}/${estabelecimentoId}`)).then(result => {
        if (!result)
            return { ok: false, data: [], message: "" };
        const ok = result.status === 200;
        const message = result.message && typeof result.message === "object"
            ? result.message.message
            : result.message;
        return { ok, data: ok ? registrosValidos(result.data) : [], message: message || "" };
    });

// Cores por TipoAcaoContrato (nome do enum na API); o texto exibido é o tipoAcaoDescricao da API
const ACAO_CORES = {
    CriacaoContrato: { color: "#2e7d32", background: "#e8f5e9" },
    AtualizacaoContrato: { color: "#1565c0", background: "#e3f2fd" },
    ExclusaoContrato: { color: "#c62828", background: "#fce4ec" },
    ReajusteIndicePeriodo: { color: "#00838f", background: "#e0f7fa" },
    ReajusteIndiceVigente: { color: "#e65100", background: "#fff3e0" },
    ReajusteSemIndice: { color: "#f57f17", background: "#fff9c4" },
    PisoNaoReducao: { color: "#6a1b9a", background: "#f3e5f5" },
    BloqueioRoyaltiesNaoCadastrados: { color: "#b71c1c", background: "#ffebee" },
};
const ACAO_COR_PADRAO = { color: "#424242", background: "#eeeeee" };

const getAcaoInfo = (registro) => ({
    label: registro.tipoAcaoDescricao || registro.tipoAcao || "",
    ...(ACAO_CORES[registro.tipoAcao] || ACAO_COR_PADRAO),
});

// BKT-1613: a API grava o nome técnico do campo (ex.: FixoRoyalties); a grade mostra o rótulo da tela.
// Campo sem tradução cadastrada aparece como veio da API.
const rotuloCampo = (campo, t) =>
    campo ? t(`contract_audit.fields.${campo}`, { defaultValue: campo }) : "";

// Opções distintas de um campo do resultado, para os filtros da tela
const opcoesDistintas = (registros, valor, rotulo) => {
    const vistos = new Map();
    (registros || []).forEach(r => {
        if (r[valor] && !vistos.has(r[valor]))
            vistos.set(r[valor], r[rotulo] || r[valor]);
    });
    return Array.from(vistos, ([value, label]) => ({ value, label }));
};

// Filtro sobre o resultado já carregado; null/undefined = todos
const filtrarAuditoria = (registros, { tipoAcao, tipoContrato } = {}) =>
    (registros || []).filter(r =>
        (!tipoAcao || r.tipoAcao === tipoAcao) &&
        (!tipoContrato || r.tipoContrato === tipoContrato));

export { getAuditoriaContrato, getAcaoInfo, rotuloCampo, opcoesDistintas, filtrarAuditoria, registrosValidos };
